import {inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';
import {mergeMap} from 'rxjs/operators';
import {from} from 'rxjs';
import {NGXLogger} from 'ngx-logger';
import {Router} from '@angular/router';
import {AuthService} from './auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    private authService: AuthService = inject(AuthService);
    private router: Router = inject(Router);
    private logger: NGXLogger = inject(NGXLogger);

    included: Array<string | RegExp> = [new RegExp('.*\/api\/.*')];

    private isIncluded(request: HttpRequest<any>): boolean {
        const url = request.url;

        return (
            this.included.findIndex(
                route =>
                    typeof route === 'string'
                        ? route === url
                        : route instanceof RegExp
                            ? route.test(url)
                            : false
            ) > -1
        );
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.isIncluded(request)) {
            this.logger.debug(`intercepting request ${request.url}`);
            return from(this.authService.tokenGetter()).pipe(mergeMap(
                (token: string | null) => {
                    if (!token) {
                        this.logger.error('Could not get token from tokenGetter function.');
                        this.authService.logout().then(() => {
                            this.logger.debug('logged out, redirecting to login page');
                            this.router.navigate(['/login']);
                        });
                    } else {
                        request = request.clone({
                            setHeaders: {
                                'Authorization': 'Bearer ' + token
                            }
                        });
                    }
                    return next.handle(request);
                }
            ));
        }

        return next.handle(request);
    }
}
